'use strict';

import template from './info_become_guide.html';

const saInfoBecomeGuide = function () {
  return {
    template: template,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: function ($window, userModel) {
      'ngInject';
      this.userModel = userModel;

      this.austria = $window.SA.country === 'AT';
    }
  };
};

export default saInfoBecomeGuide;



// WEBPACK FOOTER //
// ./app/src/modules/info/info_become_guide.component.js